

































































  import axios from 'axios';
  import {Component, Vue} from 'vue-property-decorator';
  import {Credentials} from '@/models/credentials.interface';
  import {EventBus} from '@/event-bus';
  import Constants from '@/constants';
  import DefaultPath from '@/helpers/default.path';
  import moment from 'moment';
  import StatisticItem from './StatisticItem.vue';


  @Component({ components: { 'statistic-item': StatisticItem } })
export default class LoginForm extends Vue {
  public credentials = {} as Credentials;
  public statistic = { technicalWork: { isTechnicalWorkInProgress: false, result: '' },
                       potentialDonorsCount: null,
                       relativePatientsCount: null,
                       realDonorsCount: null,
                       repeatedTKMCount: null,
                      } as any;
  public isStatisticsHealthy: boolean = true;

  get loginNotificationStyle() {
    return this.statistic && this.statistic.technicalWork.result ? '' : 'opacity: 0.0;';
  }

  public created() {
    document.title  = this.$t('SCDB') + ' | ' + this.$t('Вход в систему');
    this.loadStatisticsInformation();
  }

  public handleSubmit() {
    EventBus.$emit('showThrobber');
    this.$auth
      .login(this.credentials)
      .then((result) => {
        if (this.$router.currentRoute.path === '/') {
          const profile = result.data.data;
          const path = DefaultPath.getPath(profile);
          this.$router.push({ path });
        }

        EventBus.$emit('hideThrobber');
      })
      .catch((error) => {
        if (error.data) {
          let errorMessage = '';
          for (const name in error.data) {
            if (error.data.hasOwnProperty(name)) {
              errorMessage += error.data[name] + ' ';
            }
          }
          if (errorMessage) {
            EventBus.$emit('error', { msg: errorMessage });
          }
        }
      })
      .finally(() => {
        EventBus.$emit('hideThrobber');
      });
  }

  public currentFormattedDate() {
    return moment().locale((localStorage.lang || 'Ru').toLowerCase()).format('DD MMMM YYYY').toUpperCase();
  }

  private loadStatisticsInformation() {
    this.isStatisticsHealthy = true;

    axios.get(`${Constants.statisticsUrl}/Information`)
    .then((response) => {
      this.statistic = response.data;
    })
    .catch(() => {
      this.isStatisticsHealthy = false;
      this.statistic.technicalWork.result = this.$t('Неполадки в системе статистики');
    });

    axios.get(`${Constants.statisticsUrl}/Statistics/GetPotentialDonorsCount`)
         .then((response) => { this.statistic.potentialDonorsCount = response.data });
    axios.get(`${Constants.statisticsUrl}/Statistics/GetRealDonorsCount`)
         .then((response) => { this.statistic.realDonorsCount = response.data });
    axios.get(`${Constants.statisticsUrl}/Statistics/GetRepeatedTKMCount`)
         .then((response) => { this.statistic.repeatedTKMCount = response.data });
    axios.get(`${Constants.statisticsUrl}/Statistics/GetRelativePatientsCount`)
         .then((response) => { this.statistic.relativePatientsCount = response.data });
  }
}
